import { render } from "./admin.vue?vue&type=template&id=ee48b43c&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"

import "./admin.vue?vue&type=style&index=0&id=ee48b43c&scoped=true&lang=css"

import exportComponent from "/Users/mathieu/conductor/workspaces/miakapp-v3/lima-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee48b43c"]])

export default __exports__